module.exports = __webpack_public_path__ + "static/media/Community.a4d52c2a.svg";